import PartnershipClientsBlock from './PartnershipClientsBlock';

export default PartnershipClientsBlock;
